import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { EventBus } from './main'

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_LOGIN_TOKEN = 'AUTH_LOGIN_TOKEN'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('user-token') || '',
    status: '',
    hasLoadedOnce: false,
    profile: JSON.parse(localStorage.getItem('user-profile')),
    def: JSON.parse(localStorage.getItem('user-default'))
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    getProfile: state => state.profile,
    getDef: state => state.def
  },
  mutations: {
    [AUTH_REQUEST]: (state) => {
      state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, resp) => {
      state.status = 'success'
      state.token = resp.data.data.accessToken
      state.profile = resp.data.data.profile
      state.def = resp.data.data.default
      state.hasLoadedOnce = true
    },
    [AUTH_ERROR]: (state) => {
      state.status = 'error'
      state.hasLoadedOnce = true
    },
    [UPDATE_PROFILE]: (state, user) => {
      state.profile = user
    },
    [AUTH_LOGOUT]: (state) => {
      state.token = ''
      state.profile = null
      state.def = null
      state.hasLoadedOnce = false
      state.status = ''
    }
  },
  actions: {
    [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST)
        axios({ url: process.env.VUE_APP_API_ROOT + '/v1/me/login', data: user, method: 'POST' })
          .then(resp => {
            if (resp.data.status === 'success') {
              console.log(resp)
              const token = resp.data.data.accessToken
              localStorage.setItem('user-token', token)
              localStorage.setItem('user-profile', JSON.stringify(resp.data.data.profile))
              localStorage.setItem('user-default', JSON.stringify(resp.data.data.default))
              // Add the following line:
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              commit(AUTH_SUCCESS, resp)
              resolve(resp)
            } else {
              commit(AUTH_ERROR, resp.data.message)
              localStorage.removeItem('user-token')
              localStorage.removeItem('user-profile')
              localStorage.removeItem('user-default')
              delete axios.defaults.headers.common['Authorization']
              reject(resp.data.message)
              window.alert(resp.data.message)
            }
          })
          .catch(err => {
            commit(AUTH_ERROR, err)
            localStorage.removeItem('user-token')
            localStorage.removeItem('user-profile')
            localStorage.removeItem('user-default')
            delete axios.defaults.headers.common['Authorization']
            reject(err)
            window.alert('error: ' + err)
          })
      })
    },
    [AUTH_LOGIN_TOKEN]: ({ commit, dispatch }, loginToken) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST)
        axios({ url: process.env.VUE_APP_API_ROOT + '/v1/me/login/token', data: loginToken, method: 'POST' })
          .then(resp => {
            if (resp.data.status === 'success') {
              console.log(resp)
              const token = resp.data.data.accessToken
              localStorage.setItem('user-token', token)
              localStorage.setItem('user-profile', JSON.stringify(resp.data.data.profile))
              localStorage.setItem('user-default', JSON.stringify(resp.data.data.default))
              // Add the following line:
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              commit(AUTH_SUCCESS, resp)
              resolve(resp)
            } else {
              commit(AUTH_ERROR, resp.data.message)
              localStorage.removeItem('user-token')
              localStorage.removeItem('user-profile')
              localStorage.removeItem('user-default')
              delete axios.defaults.headers.common['Authorization']
              reject(resp.data.message)
              window.alert(resp.data.message)
            }
          })
          .catch(err => {
            commit(AUTH_ERROR, err)
            localStorage.removeItem('user-token')
            localStorage.removeItem('user-profile')
            localStorage.removeItem('user-default')
            delete axios.defaults.headers.common['Authorization']
            reject(err)
            window.alert('error: ' + err)
          })
      })
    },
    [UPDATE_PROFILE]: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/me')
          .then(resp => {
            if (resp.data.status === 'success') {
              localStorage.setItem('user-profile', JSON.stringify(resp.data.data))
              commit(UPDATE_PROFILE, resp.data.data)
              EventBus.$emit('profileUpdated', resp.data.data)
              resolve(resp)
            } else {
              reject(resp.data.message)
              console.log(resp.data.message)
            }
          })
          .catch(err => {
            reject(err)
            console.log('error: ' + err)
          })
      })
    },
    [AUTH_LOGOUT]: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_LOGOUT)
        localStorage.removeItem('user-token')
        localStorage.removeItem('user-profile')
        localStorage.removeItem('user-default')
        EventBus.$emit('logout')

        // remove the axios default header
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  strict: debug
})
